import PropTypes from 'prop-types';
import { Button as MuiButton, CircularProgress } from '@material-ui/core';
import cx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootSquare: {
    minHeight: 25,
    minWidth: 80,
    lineHeight: 'normal',
    textTransform: 'unset',
  },
  rootOval: {
    minHeight: 25,
    minWidth: 80,
    lineHeight: 'normal',
    textTransform: 'unset',
    borderRadius: 20,
  },
  rootRound: {
    lineHeight: 'normal',
    textTransform: 'unset',
    borderRadius: '50%',
    minWidth: 'unset',
  },
  sizeXs: {
    padding: '0px 10px',
  },
  sizeSm: {
    padding: '1px 15px',
  },
  sizeMd: {
    padding: '2px 20px',
  },
  sizeLg: {
    padding: '2px 30px',
  },
  sizeRoundXs: {
    heigth: 20,
    width: 20,
  },
  sizeRoundSm: {
    height: 30,
    width: 30,
  },
  sizeRoundMd: {
    height: 40,
    width: 40,
  },
  sizeRoundLg: {
    height: 50,
    width: 50,
  },
  contained: {
    color: theme.palette.custom.componentText,
    backgroundColor: theme.palette.custom.component,
  },
  outlined: {
    color: theme.palette.custom.component,
    backgroundColor: '#ffffff',
    borderColor: theme.palette.custom.component,
  },
  text: {
    color: theme.palette.custom.component,
  },
  sizeSmall: {},
  sizeLarge: {
    minWidth: 90,
    minHeight: 30,
    fontSize: '0.675rem',
    padding: '5px 16px',
  },
  progress: {
    position: 'absolute',
    color: theme.palette.custom.component,
  },
}));

const Button = (props) => {
  const classes = useStyles();
  const {
    children,
    className,
    variant = 'contained',
    type = 'square', // square, oval, round
    loading,
    color, // blue, grey
    style = {},
    size,
    disabled = false,
    ...rest
  } = props;

  return (
    <MuiButton
      variant={variant}
      size={size}
      color="secondary"
      className={className}
      classes={{
        root: cx({
          [classes.rootSquare]: type === 'square',
          [classes.rootOval]: type === 'oval',
          [classes.rootRound]: type === 'round',
          [classes.sizeXs]: size === 'xs' && type !== 'round',
          [classes.sizeSm]: size === 'sm' && type !== 'round',
          [classes.sizeMd]: size === 'md' && type !== 'round',
          [classes.sizeLg]: size === 'lg' && type !== 'round',
          [classes.sizeRoundXs]: size === 'xs' && type === 'round',
          [classes.sizeRoundSm]: size === 'sm' && type === 'round',
          [classes.sizeRoundMd]: size === 'md' && type === 'round',
          [classes.sizeRoundLg]: size === 'lg' && type === 'round',
        }),
        sizeLarge: classes.sizeLarge,
        contained: cx({
          [classes.contained]: variant === 'contained',
        }),
        outlined: cx({
          [classes.outlined]: variant === 'outlined',
        }),
        text: classes.text,
      }}
      disabled={loading || disabled}
      style={{
        ...style,
        backgroundColor:
          variant === 'contained' ? (disabled ? '#b3b3b3' : color || '#0073d1') : 'unset',
        borderColor: variant === 'outlined' ? (disabled ? '#b3b3b3' : color || '#0073d1') : 'unset',
      }}
      {...rest}
    >
      {children}
      {loading && <CircularProgress size={20} />}
    </MuiButton>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
};

export default Button;
